module.exports = __webpack_public_path__ + "static/19-Affinity-Mapping-4380749fb5cb0eebf8b1a66a32e1613f.jpg";